import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttributeChangeSchedule } from '../model/schedule/attribute-change-schedule';

const changeScheduleBaseUrl = `/upstream/gymfinder/internal/admin/v1/attribute-change-schedule/`;

@Injectable({
  providedIn: 'root',
})
export class AttributeChangeScheduleService {
  constructor(private httpClient: HttpClient) {}

  public getAllByGymId(gymId: string): Observable<AttributeChangeSchedule[]> {
    const url = changeScheduleBaseUrl + `?gymId=${gymId}`;
    return this.httpClient.get<AttributeChangeSchedule[]>(url, {
      withCredentials: true,
    });
  }

  public create(schedule: AttributeChangeSchedule): Observable<void> {
    return this.httpClient.post<void>(changeScheduleBaseUrl, schedule, {
      withCredentials: true,
    });
  }

  public delete(id: string): Observable<void> {
    const url = changeScheduleBaseUrl + `${id}`;
    return this.httpClient.delete<void>(url, { withCredentials: true });
  }
}
